const allaccreceivableagingdetail = { data: [], loading: true };
export const GetAllAccReceivableAgingDetailTransaction = (
  state = allaccreceivableagingdetail,
  action,
) => {
  switch (action.type) {
    case "get_allaccreceivableagingdetailtransaction":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
